import { ProfilePhone } from "./ProfilePhone";

export default ProfilePhone;
